import { isNativeRigBridgeAvailable, createNativeRigBridgeTransport } from './nativeBridge';

const RECONNECT_MS = 3000;

export function createRigBridgeConnection({
  callsign,
  settingsRef,
  onOpen,
  onMessage,
  onClose,
  onError
}) {
  if (isNativeRigBridgeAvailable()) {
    const transport = createNativeRigBridgeTransport({
      onOpen,
      onMessage,
      onClose,
      onError
    });
    transport.open();
    return { transport, isNative: true };
  }

  let ws;
  try {
    ws = new WebSocket(settingsRef.current.bridgeUrl);
  } catch (connectError) {
    onError?.(connectError);
    return { transport: null, isNative: false };
  }

  ws.onopen = () => {
    onOpen?.();
    ws.send(JSON.stringify({
      type: 'hello',
      callsign,
      settings: settingsRef.current
    }));
  };
  ws.onmessage = onMessage;
  ws.onclose = onClose;
  ws.onerror = () => onError?.(new Error('Rig Bridge connection failed'));
  return { transport: ws, isNative: false };
}

export function sendRigBridgeMessage(transport, isNative, payload) {
  const body = typeof payload === 'string' ? payload : JSON.stringify(payload);
  if (!transport) {
    return;
  }
  if (isNative) {
    transport.send(body);
    return;
  }
  if (transport.readyState === WebSocket.OPEN) {
    transport.send(body);
  }
}

export { RECONNECT_MS };
